import axios from 'axios'
import config from 'config'

export class LAPIClient {
  constructor(client) {
    this.client = client
  }

  async info(msg, referer, request_id = '') {
    return this.client.post('log', {
      level: 'info',
      msg,
      referer,
      request_id,
    })
  }

  async warning(msg, referer, request_id = '') {
    return this.client.post('log', {
      level: 'warning',
      msg,
      referer,
      request_id,
    })
  }

  async error(msg, referer, request_id = '') {
    return this.client.post('log', {
      level: 'error',
      msg,
      referer,
      request_id,
    })
  }
}

export function lapiFromConfig() {
  return new LAPIClient(axios.create({ baseURL: `${config.lapiURL}` }))
}
